import { useState } from 'react';
import './style/style.css';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Modal from 'react-bootstrap/Modal';

const textContent = {
  en: {
    BlockA: 'Block A',
    BlockB: 'Block B',
    BlockBC: 'Block BC',
    BlockC: 'Block C',
    BlockD: 'Block D',
    BlockE: 'Block E',
    MainAttractionsHeading: 'Main Attractions',
    exhibits: {
      
      BlockA: [
        {
          ReadMore: 'Read More',
          title: 'Welcome zone',
          description: 'Behold the magnificent Sudarshan Chakra, an eight ton marvel suspended from the ceiling. Crafted with precision by skilled artisans, it is adorned with thousands of gems, radiating celestial power. A backdrop of cascading water enhances its grandeur, offering visitors a captivating and divine visual experience.',
          image: '/images/block-a/block-a-image-1.jpg',
        },
        {
          ReadMore: 'Read More',
          title: 'Birth of an Epic',
          description: 'The briefing area features a remarkable projection depicting a dialogue between Ved Vyas and Lord Brahma, focusing on the collection of Vedic knowledge and its dissemination through the creation of the invaluable epic, the Mahabharat. In this divine discourse, Lord Ganesh assumes a pivotal role as the scribe, transcribing the epic as narrated by Ved Vyas.',
          image: '/images/block-a/block-a-image-2.jpg',
        },
        {
          ReadMore: 'Read More',
          title: 'The 48-Kos Pilgrimage',
          description: 'This installation captures the 48-kos yatra of Kurukshetr, featuring 18 temples and 4 Yakshas within Haryana. It offers a rich experience through a 3D installation, projection film, murals and an informative kiosk, providing visitors with a deep understanding of the narrative.',
          image: '/images/block-a/block-a-image-3.jpg',
        },
      ],
      BlockB: [
        {
          ReadMore: 'Read More',
          title: 'Yagyaseni—Born from the Sacrificial Fire',
          description: 'In this installation, the pivotal moment of Draupadi"s birth emerging from the fire, is brought to life through a hyper-realistic sculpture. Her emergence from the fire symbolizes her purity and divine origin.',
          image: '/images/block-b/block-b-image-1.jpg',
        },
        {
          ReadMore: 'Read More',
          title: "Draupadi's Swayamwar",
          description: "This exhibit presents Draupadi's Swayamvar through a hyper-realistic sculpture of Arjun aiming at a revolving fish's eye. King Drupad’s challenge tested the suitors’ skill using only the fish’s reflection. Arjun’s precise shot secured his victory, resulting in Draupadi marrying him as per the Swayamvar’s conditions.",
          image: '/images/block-b/block-b-image-2.jpg',
        },
        {
          ReadMore: 'Read More',
          title: 'Draupadi and Bheeshm - The Dharma Dialogue',
          description: 'After the dice game, Draupadi’s dialogue symbolizes profound defiance in the Mahabharat. Her words challenge the unjust social order that allowed her to be gambled away. By questioning the game’s legitimacy and confronting the Kuru elders, she embodies resistance against oppression, asserting moral authority, justice, and unwavering dignity.',
          image: '/images/block-b/block-b-image-3.jpg',
        },
      ],
      BlockBC: [
        {
          ReadMore: 'Read More',
          title: "The Pandav's Trial of Exile",
          description: "The Pandavs spent twelve years in arduous exile and one year in incognito, during which they understood the importance of humility, patience, and the transience of worldly life. These experiences strengthened them mentally and spiritually, preparing them for the reclamation of their kingdom and the great war of Kurukshetr.",
          image: '/images/block-bc/block-bc-image-1.jpg',
        },
        {
          ReadMore: 'Read More',
          title: 'Krishna’s Final Warning',
          description: 'After years of exile and disguise, the Pandavs longed for their rightful throne, but Duryodhan refused to yield. In a final plea for peace, Lord Krishna asked only for five  villages, yet Duryodhan spurned the offer. Then Krishna revealed his cosmic form, declaring that war was now certain. His vast form embodied the universe itself—past, present and future within. Thus, war remained the final fate to embrace.',
          image: '/images/block-bc/block-bc-image-2.jpg',
        },
        {
          ReadMore: 'Read More',
          title: 'The Epic Battle',
          description: 'The Mahabharat’s great war is depicted from its beginning to the final climactic moments, highlighting the bravery of iconic warriors like Bhishm, Dronacharya, Karn, and Abhimanyu. It includes the intense mace battle between Duryodhan and Bhim, capturing the eternal conflict between dharm and adharm. The narrative brings forth the deep emotions of the characters and the fierce intensity of this historic battle.',
          image: '/images/block-bc/block-bc-image-3.jpg',
        },
      ],
      BlockC: [
        {
          ReadMore: 'Read More',
          title: "Bheeshm's Bed of Arrows",
          description: 'At the war’s end, Jambudweep’s warriors faced immense loss. Bhishm, upon his bed of arrows, chose to depart in Uttarayan. Troubled by doubts of kingship, Yudhishthir sought his counsel. Bhishm imparted the essence of Rajdharm. His timeless wisdom remains deeply relevant even today.',
          image: '/images/block-c/block-c-image-1.jpg',
        },
        {
          ReadMore: 'Read More',
          title: "Dating of Mahabharat",
          description: "The Mahabharat’s dating remains debated—history or myth, fact or imagination. Vyas’s text mentions celestial events matching modern calculations, placing the war 4000–5000 years ago. Excavations of submerged Dwarka provide further evidence. Though its exact timing remains uncertain, the epic endures, inspiring humanity with timeless lessons on dharma and truth.",
          image: '/images/block-c/block-c-image-2.jpg',
        },
        {
          ReadMore: 'Read More',
          title: 'Ancient Artefacts',
          description: 'These artefacts dated back to before the 10th century – each one telling a fascinating story from our glorious past.',
          image: '/images/block-c/block-c-image-3.jpg',
        },
        
      ],
      BlockD: [
        {
          ReadMore: 'Read More',
          title: 'Ascent to Heaven',
          description: 'Now you are on that sacred path where the Pandavs once walked. After ruling for many years following the war, they renounced worldly life and departed towards the Himalayas. One by one, Draupadi and the brothers perished, while only Yudhishthir, steadfast and pure, attained heaven in his mortal form.',
          image: '/images/block-d/block-d-image-2.jpg',
        },
        {
          ReadMore: 'Read More',
          title: "Ashwatthama—Cursed Warrior",
          description: "Ashwatthama’s fierce form is depicted amidst wounded Pandav soldiers. After Dron’s death, overwhelmed by rage, he unleashed the Narayanastra to massacre the Pandav lineage and attempted to kill Abhimanyu’s unborn child at night, violating the rules of war.",
          image: '/images/block-d/block-d-image-1.jpg',
        },        
        {
          ReadMore: 'Read More',
          title: "Dhritirashtr's Anguish",
          description: 'After the war, when the Pandavs came to meet Dhritarashtr, he attempted to kill Bhim under the pretext of an embrace. Lord Krishna intervened, replacing Bhim with an iron statue, which Dhritarashtr crushed, injuring himself. Krishna reminded him that the true blame lay not with the Pandavs but with his blind attachment and choices. In the end, Dhritarashtr realized his mistake and embraced the Pandavs with remorse.',
          image: '/images/block-d/block-d-image-3.jpg',
        },
      ],
      BlockE: [
        {
          ReadMore: 'Read More',
          title: 'Eternal Wisdom of the Gita',
          description: "At Kurukshetr, Lord Krishna revealed the timeless wisdom of the Bhagavad Gita to Arjun. When Arjun faltered, seeing his elders and kin before him, Krishna urged him to rise above doubt and  recognize duty and righteousness. Through verses on karma, self-realization, and dharma, Krishna gave humanity the universal path of righteous living. The Gita remains a guiding light for all ages.",
          image: '/images/block-e/block-e-image-2.jpg',
        },
        {
          ReadMore: 'Read More',
          title: 'The Gita Unveiled',
          description: "In this interactive zone, you may ask your questions. Lord Krishna’s timeless wisdom from the Bhagavad Gita guides every answer. From duty and courage to life's deepest mysteries, the Gita speaks to all. Let this eternal dialogue enlighten your mind and soul.",
          image: '/images/block-e/block-e-image-3.jpg',
        },
        {
          ReadMore: 'Read More',
          title: 'Krishna’s Eternal Blessing',
          description: "Behold Krishna in his divine form — the eternal guide of righteousness. His blessings illuminate the path of dharma for every soul that stands before him.",
          image: '/images/block-e/block-e-image-1.jpg',
        },
        
      ],
      
    },
  },
  hi: {    
    BlockA: 'ब्लॉक - ए',
    BlockB: 'ब्लॉक - बी',
    BlockBC: 'ब्लॉक - बीसी',
    BlockC: 'ब्लॉक - सी',
    BlockD: 'ब्लॉक - डी',
    BlockE: 'ब्लॉक - ई',
    MainAttractionsHeading: 'मुख्य आकर्षण',
    exhibits: {
      BlockA: [
        {
          ReadMore: 'और पढ़ें',
          title: 'स्वागत कक्ष',
          description: 'यहाँ आपके समक्ष है भव्य सदुर्शन चक्र। आठ टन वजनी यह चक्र छत से निलंबित है। कुशल कारीगरों ने इसे बारीकी से गढ़ा है और हज़ारों रन्नों से अलंकृत किया है। इसकी दिव्य आभा को बहते जल की पृष्ठभूमि और भी मनोहारी बना देती है।',
          image: '/images/block-a/block-a-image-1.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'महाकाव्य का सृजन',
          description: "इस चित्र में भगवान ब्रह्मा और वेद व्यास के मध्य होने वाला संवाद प्रदर्शित किया गया है। बातचीत का विषय वैदिक ज्ञान को इकठ्ठा करना और उसको दुनिया में फैलाने के लिए महाभारत जैसे बहुमूल्य काव्य का निर्माण करना है। इस दिव्य प्रवचन में, भगवान गणेश लेखक के रूप में एक महत्वपूर्ण भूमिका निभाते हैं और वेद व्यास द्वारा वर्णित महाकाव्य का प्रतिलेखन करते हैं।",
          image: '/images/block-a/block-a-image-2.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: '48–कोस की परिक्रमा',
          description: "यह स्थापना कुरुक्षेत्र की 48-कोस यात्रा का सार प्रस्तुत करती है, जिसमें हरियाणा की सीमाओं के भीतर 18 मंदिर और 4 यक्ष शामिल हैं। इसमें त्रिआयामी चित्र, प्रोजेक्शन फिल्म, भित्ति चित्र तथा सूचनात्मक कियोस्क जैसे तत्व दर्शकों को गहन अनुभव प्रदान करते हैं।",
          image: '/images/block-a/block-a-image-3.jpg',
        },
      ],
      BlockB: [
        {
          ReadMore: 'और पढ़ें',
          title: 'याज्ञसेनी—अग्निसुता द्रौपदी',
          description: "यहाँ इस स्थापना में, द्रौपदी के जन्म के महत्वपूर्ण क्षण को, आग से उभरते हुए, एक अति-यथार्थवादी माध्यम से जीवंत किया गया है। द्रौपदी का आग से उभरना उनकी शुद्धता और दिव्य उत्पत्ति का प्रतीक है।",
          image: '/images/block-b/block-b-image-1.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'द्रौपदी का स्वयंवर',
          description: "यह प्रसंग द्रौपदी के स्वयंवर का अनुभव प्रस्तुत करती है, जिसमें अर्जुन की अति-यथार्थवादी मूर्ति धनुष लिए मछली की आँख को भेदने के लिए तैयार है। राजा ध्रुपद की चुनौती पूरी कर अर्जुन ने कौशल दिखाया और स्वयंवर के अनुसार द्रौपदी से विवाह संपन्न हुआ।",
          image: '/images/block-b/block-b-image-2.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'द्रौपदी-भीष्म धर्म संवाद',
          description: "चौसर खेल के बाद द्रौपदी का संवाद महाभारत में गहन प्रतिरोध का प्रतीक है। उनके शब्द अन्यायपूर्ण सामाजिक व्यवस्था के खिलाफ अवज्ञा और उत्पीड़न के प्रतिरोध को व्यक्त करते हैं। खेल की वैधता पर सवाल उठाकर और बुजुर्गो के समक्ष अपने अधिकार की अवहेलना बताकर, वे न्याय और धैर्य का प्रतीक हैं।",
          image: '/images/block-b/block-b-image-3.jpg',
        },
      ],
      BlockBC: [
        {
          ReadMore: 'और पढ़ें',
          title: 'पांडवों का वनवास',
          description: "पांडवों ने बारह वर्ष कठिन वनवास और एक वर्ष अज्ञातवास में बिताए, जहाँ उन्होंने विनम्रता, धैर्य और सांसारिक जीवन की क्षणभंगुरता को समझा। इन अनुभवों ने उन्हें मानसिक और आध्यात्मिक रूप से मज़बूत किया, जिससे वे अपने राज्य की पुनः प्राप्ति और कुरुक्षेत्र के युद्ध के लिए तैयार हुए।",
          image: '/images/block-bc/block-bc-image-1.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'कृष्ण की चेतावनी',
          description: "वनवास और अज्ञातवास के बाद, पांडव अपने अधिकारों की वापसी चाहते थे, लेकिन दुर्योधन को यह स्वीकार नहीं था। शाति की आखिरी कोशिश में भगवान कृष्ण ने पाँच ग्रामों का प्रस्ताव रखा, जिसे दुर्योधन ने ठुकरा दिया। तब कृष्ण ने अपना  विराट रूप धारण कर चेतावनी दी कि अब युद्ध अवश्यंभावी है। यह स्वरूप समस्त ब्रह्मांड का प्रतीक था, जिसमें अतीत, वर्तमान और भविष्य समाहित थे। अब केवल युद्ध ही अंतिम विकल्प बचा था।",
          image: '/images/block-bc/block-bc-image-2.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'महासंग्राम',
          description: "महाभारत का महासंग्राम युद्ध के आरंभ से लेकर अंतिम निर्णायक क्षणों तक की गाथा प्रस्तुत करती है। इसमें भीष्म, द्रोणाचार्य, कर्ण, अभिमन्यु जैसे प्रमुख योद्धाओं के साहसिक संघर्ष, और दुर्योधन तथा भीम के बीच गदा युद्ध का उल्लेख है। यह कथा धर्म और अधर्म के बीच जारी महान संग्राम की नाटकीयता, पात्रों की भावनाएं और युद्ध की भयंकरता को प्रभावशाली रूप से दर्शाती है।",
          image: '/images/block-bc/block-bc-image-3.jpg',
        },
      ],
      BlockC: [
        {
          ReadMore: 'और पढ़ें',
          title: 'भीष्म शरशय्या',
          description: "महाभारत युद्ध में जम्बूद्वीप के वीरों को भारी क्षति हुई। पितामह भीष्म शरशय्या पर उत्तरायण में देह त्याग कर गए। युद्ध के बाद संशयग्रस्त युधिष्ठिर को उन्होंने राजधर्म के सिद्धांत बताए। उनका यह अमर उपदेश आज भी प्रेरणादायी है।",
          image: '/images/block-c/block-c-image-1.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'महाभारत का काल निर्धारण',
          description: "महाभारत की तिथि पर सदियों से विवाद है- इतिहास या मिथक, यथार्थ या कल्पना। वेदव्यास द्वारा वर्णित ग्रह-नक्षत्र स्थितियाँ आधुनिक गणनाओं से मेल खाकर युद्ध को 4000-5000 वर्ष पूर्व मानती हैं। समुद्र में डूबी द्वारका के प्रमाण भी इसकी गवाही देते हैं। तिथि अनिश्चित, संदेश शाश्वत ।",
          image: '/images/block-c/block-c-image-2.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'प्राचीन कलाकृतियाँ ',
          description: "ये कलाकृतियाँ 10वीं शताब्दी से भी पहले की हैं — प्रत्येक अपने भीतर हमारे गौरवशाली अतीत की एक अद्भुत कहानी समेटे हुए है।",
          image: '/images/block-c/block-c-image-3.jpg',
        },
        
      ],
      BlockD: [
        {
          ReadMore: 'और पढ़ें',
          title: 'स्वर्गलोक यात्रा',
          description: "अब आप उस पवित्र मार्ग पर हैं जहाँ पांडव भी चले थे। युद्ध के पश्चात् कई वर्ष शासन करने के बाद, उन्होंने सांसारिक जीवन छोड़ हिमालय की ओर प्रस्थान किया। यात्रा में द्रौपदी और चारों भाइयों का निधन हुआ, केवल युधिष्ठिर सत्य और धर्म के कारण जीवित रह गए।",
          image: '/images/block-d/block-d-image-2.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'अश्वत्थामा - श्रापित योद्धा',
          description: "अश्वत्थामा की यह प्रभावशाली प्रतिमा उनकी वीरता और क्रूरता को दर्शाती है। महाभारत के अंतिम दिन, द्रोण की मृत्यु के बाद, उन्होंने नारायण अस्त्र से पांडव वंश का संहार किया और अभिमन्यु के अजन्मे पुत्र को मारने का प्रयास किया। यह कृत्य युद्ध के नियमों का उल्लंघन था और युद्ध की भयावहता को दर्शाता है।",
          image: '/images/block-d/block-d-image-1.jpg',
        },
        
        {
          ReadMore: 'और पढ़ें',
          title: 'धृतराष्ट्र की वेदना',
          description: "महाभारत युद्ध के बाद जब पांडव धृतराष्ट्र से मिलने पहुँचे, तो उन्होंने भीम को गले लगाने के बहाने मारने का प्रयास किया। भगवान कृष्ण ने समय रहते भीम को बचा लिया और उनके स्थान पर लौहप्रतिमा रख दी। प्रतिमा को तोड़ते हुए धृतराष्ट्र स्वयं घायल हो गए। कृष्ण ने उन्हें समझाया कि असली दोष पांडवों का नहीं, बल्कि उनके अपने पुत्रमोह और निर्णयों का था। अंततः धृतराष्ट्र ने अपनी भूल स्वीकार की और पांडवों को गले लगाया।",
          image: '/images/block-d/block-d-image-3.jpg',
        },
      ],
      BlockE: [
        
        {
          ReadMore: 'और पढ़ें',
          title: 'गीता का शाश्वत ज्ञान',
          description: "कुरुक्षेत्र की रणभूमि पर भगवान श्रीकृष्ण ने अर्जुन को श्रीमद्भगवद्‌गीता का अमर ज्ञान दिया। जब अर्जुन अपने परिजनों को सामने देखकर विचलित हुए, तब कृष्ण ने उन्हें मोह और संशय त्यागकर धर्म और कर्तव्य को पहचानने का उपदेश दिया। कर्म, आत्मा और धर्म के गूढ़ सिद्धांतों के माध्यम से कृष्ण ने मानवता को जीवन का शाश्वत मार्ग दिखाया। गीता आज भी मानवता को दिशा और प्रकाश देती है।",
          image: '/images/block-e/block-e-image-2.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'गीता साक्षात्कार',
          description: "इस संवादात्मक क्षेत्र में आप अपने प्रश्न पूछ सकते हैं। भगवान कृष्ण का शाश्वत ज्ञान, भगवद्‌गीता से, हर उत्तर में आपका मार्गदर्शन करेगा। धर्म, साहस और जीवन के गूढ़ रहस्यों का उत्तर गीता में निहित है। यह अमर संवाद आपके मन और आत्मा को आलोकित करेगा।",
          image: '/images/block-e/block-e-image-3.jpg',
        },
        {
          ReadMore: 'और पढ़ें',
          title: 'कृष्ण - आशीष',
          description: "यहाँ श्रीकृष्ण अपने दिव्य रूप में विराजमान हैं- धर्म के शाश्वत मार्गदर्शक । उनके आशीर्वाद से हर दर्शक का मार्ग आलोकित होता है।",
          image: '/images/block-e/block-e-image-1.jpg',
        },
      ],
      // Other block exhibits here for hi
    },
  },
};




const Block = ({ blockId, blockLabel, exhibits, onExhibitClick, textContent }) => (
  <div id={blockId} className={`item ${blockLabel.toLowerCase().replace(/\s/g, '-')}`}>
    <div className="block-label">{blockLabel}</div>
    <div className="items-row">
      {exhibits.map((exhibit, index) => (
        <div className="exhibits-item" key={index}>
          <span className="frame-border">
            <img src="/images/block-card-border.png" alt="" />
          </span>
          <div className="exhibits-inner">
            <div className="exhibits-image">
              <img src={exhibit.image} alt={exhibit.title} />
            </div>
            <div className="exhibits-info">
              <h4>{exhibit.title}</h4>
              <p>{exhibit.description}</p>
              <div
                onClick={() => onExhibitClick(exhibit)}
                className="custom-globle-button"
              >
                {exhibit.ReadMore} {' '}
                <span>
                  <img
                    alt="MuseumExhibits-2"
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCA0MiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODQ4Mjg1IDhMNDAuNjE2MSA4TTQwLjYxNjEgOEwzMS41MjYzIDFNNDAuNjE2MSA4TDMxLjUyNjMgMTUiIHN0cm9rZT0iIzNBM0EzQSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const MuseumExhibits = ({ language }) => {  

  const [show, setShow] = useState(false);
  const [selectedExhibit, setSelectedExhibit] = useState(null);

  const handleClose = () => setShow(false);
  const handleExhibitClick = (exhibit) => {
    setSelectedExhibit(exhibit);
    setShow(true);
  };

  const exhibitsOptions = {
    loop: false,
    margin: 60,
    nav: true,
    dots: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
    },
  };

  const blocks = Object.keys(textContent[language].exhibits).map((key) => ({
    blockId: key.toLowerCase().replace('block', 'block-'),
    blockLabel: textContent[language][key],
    exhibits: textContent[language].exhibits[key],
  }));

  return (
    <>
      <div
        id="main-attractions"
        className="Museum-Exhibits"
        style={{ backgroundImage: 'url(/images/gradient-bg.svg)' }}
      >
        <div className="section-heading">
          <h2>{textContent[language].MainAttractionsHeading}</h2>
        </div>

        <div className="container with-custom-arrow">
          <OwlCarousel className="owl-theme" {...exhibitsOptions} key={language}>
            {blocks.map((block, index) => (
              <Block
                key={index}
                blockId={block.blockId}
                blockLabel={block.blockLabel}
                exhibits={block.exhibits}
                onExhibitClick={handleExhibitClick}
              />
            ))}
          </OwlCarousel>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="main_attraction_modal_detail"
      >
        {selectedExhibit && (
          <>
            <Modal.Header closeButton>
              <Modal.Title>{textContent[language].MainAttractionsHeading}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="exhibits-image">
                <img src={selectedExhibit.image} alt={selectedExhibit.title} />
              </div>
              <div className="exhibits-info">
                <h4 className="exhibits-heading">{selectedExhibit.title}</h4>
                <p className="exhibits_content">{selectedExhibit.description}</p>
              </div>
            </Modal.Body>
          </>
        )}
      </Modal>
    </>
  );
};

export default MuseumExhibits;
